<template>
  <InlineActionConfirmation
    :disabled="changesAreDisabled"
    @confirm="emit('deleteAttachment')"
  >
    <template #default="{ openConfirmation }">
      <div class="tw-flex">
        <SfButtonIcon
          icon="download"
          :seamless="true"
          :small="true"
          @click="handleDownload"
        />
        <SfButtonIcon
          v-if="!isMsgAttachment"
          icon="external-link-alt"
          :seamless="true"
          :small="true"
          @click="handlePreview"
        />
        <SfButtonIcon
          v-if="showDeleteButton"
          icon="trash"
          class="hover:tw-text-sf-danger-light-1"
          :seamless="true"
          :small="true"
          @click="openConfirmation"
        />
      </div>
    </template>
  </InlineActionConfirmation>
</template>

<script setup lang="ts">
import type { Attachment } from './types'

import { computed } from 'vue'

import { SfButtonIcon } from '@app/shared/vue/components/sf-button'
import InlineActionConfirmation from '@app/shared/vue/components/molecules/inline-action-confirmation/inline-action-confirmation.vue'
import {
  previewAttachment,
  downloadAttachment,
} from '@app/utils/attachment-helpers'

interface Props {
  attachment: Attachment
  changesAreDisabled: boolean
  showDeleteButton?: boolean
}

const { attachment, showDeleteButton = true } = defineProps<Props>()

// .msg files are previewed inline via multi-tab PDFTron in the side-by-side
// viewer. The "open in new tab" affordance would route to the legacy
// /permanent_mails/:id page which is now redundant.
const isMsgAttachment = computed(() =>
  attachment.name?.toLowerCase().endsWith('.msg')
)

const emit =
  defineEmits<{
    deleteAttachment: []
  }>()

function handleDownload(): void {
  downloadAttachment(attachment.document_id.toString())
}

function handlePreview(): void {
  previewAttachment(attachment.document_id.toString())
}
</script>
